import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import isEqual from 'hs-lodash/isEqual';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
// @ts-expect-error migrate dependency
import { getId } from 'reporting-action-components/data/schemas/dashboardSchema';
// @ts-expect-error migrate dependency
import { useUserRoleForDashboard } from 'reporting-action-components/utils/trackingUtils';
// @ts-expect-error migrate dependency
import { getDashboardReports } from 'dashboard-lib/public/dashboard/dashboard-logic';
import { track, EVENTS
// @ts-expect-error migrate dependency
} from 'dashboard-ui-components/tracking/DashboardUITracker';
import { getDashboardDataSources } from 'platform-dashboard-ui/lib/dashboardDataSourceUtils';
import { selectDashboardFilters, removeCurrentDashboardFilters, selectIsDashboardFilterPanelOpen, closeDashboardFiltersPanel, toggleDashboardFiltersPanel, selectHasDashboardFiltersInitialized } from '../../../../ducks/dashboardFilters';
import { usePrevious } from '../../../../lib/usePrevious';
import { useDashboardReportsOverrides } from '../../../../ducks/dashboard-reports';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { SavedDashboardFiltersPanel } from './savedDashboardFilters';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const DashboardFiltersButton = ({
  dashboard
}) => {
  const isPanelOpen = useSelector(selectIsDashboardFilterPanelOpen);
  const dashboardId = getId(dashboard);
  const hasInitializedDashboardFilters = useSelector(selectHasDashboardFiltersInitialized(dashboardId));
  const appliedFilters = useSelector(selectDashboardFilters(dashboardId));
  const appliedFiltersCount = appliedFilters.length;
  const reports = getDashboardReports(dashboard);
  const userRole = useUserRoleForDashboard(dashboard);
  const prevAppliedFilters = usePrevious(appliedFilters);
  const hasChangedFilters = !isEqual(appliedFilters, prevAppliedFilters);
  const dispatch = useDispatch();
  useDashboardReportsOverrides(dashboardId);
  const trackCloseDashboardFilters = useCallback(() => {
    track(EVENTS.closeDashboardFilters, {
      actionType: 'explore',
      action: 'close-filters',
      assetType: 'dashboard',
      count: hasChangedFilters ? appliedFiltersCount : undefined,
      role: userRole
    });
  }, [appliedFiltersCount, hasChangedFilters, userRole]);
  if (reports.length === 0 || !hasInitializedDashboardFilters) {
    return null;
  }
  const dataSources = getDashboardDataSources(dashboard);
  const isDisabled = dataSources.length === 0 && appliedFilters.length === 0;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(UIFlex, {
      align: "center",
      children: [/*#__PURE__*/_jsx(UITooltip, {
        disabled: !isDisabled,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dashboardHeader.dashboardFilters.allFilters.noFilterableReports"
        }),
        children: /*#__PURE__*/_jsx(UIButton, {
          "data-test-id": "dashboard-filters-action",
          use: "link",
          onClick: () => {
            dispatch(toggleDashboardFiltersPanel());
            if (isPanelOpen) {
              trackCloseDashboardFilters();
            } else {
              track(EVENTS.openDashboardFilters, {
                actionType: 'explore',
                action: 'open-filters',
                assetType: 'dashboard',
                objectTypeCount: dataSources.length,
                role: userRole
              });
            }
          },
          disabled: isDisabled,
          children: /*#__PURE__*/_jsxs(UITruncateString, {
            maxWidth: 250,
            children: [/*#__PURE__*/_jsx(UIIcon, {
              name: "filter"
            }), /*#__PURE__*/_jsx(FormattedMessage, {
              message: appliedFiltersCount > 0 ? 'dashboardHeader.dashboardFilters.allFilters.advancedFiltersActive' : 'dashboardHeader.dashboardFilters.allFilters.advancedFiltersInactive',
              options: {
                count: appliedFiltersCount
              }
            })]
          })
        })
      }), appliedFiltersCount > 0 && /*#__PURE__*/_jsx(UIButton, {
        className: "m-left-4 m-right-2",
        use: "link",
        "data-test-id": 'subheader-clear-all-filters-button',
        onClick: () => {
          dispatch(removeCurrentDashboardFilters({
            dashboardId
          }));
          track(EVENTS.clearDashboardFilters, {
            actionType: 'explore',
            action: 'clear-filters',
            assetType: 'dashboard',
            role: userRole,
            interactionSource: 'dashboard'
          });
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'dashboardHeader.dashboardFilters.allFilters.clear'
        })
      })]
    }), isPanelOpen && /*#__PURE__*/_jsx(SavedDashboardFiltersPanel, {
      dashboard: dashboard,
      onClose: () => {
        dispatch(closeDashboardFiltersPanel());
        trackCloseDashboardFilters();
      }
    })]
  });
};
export default DashboardFiltersButton;